'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-is.production.min.js');
} else {
  module.exports = require('./cjs/react-is.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux/node_modules/hoist-non-react-statics/node_modules/react-is/index.js
// module id = 1173
// module chunks = 0